/**
 * @file: PresenceDot.tsx
 *
 * The little green "online" dot. Presentational only — the caller decides
 * whether to render it (via `useIsOnline`) and positions it (usually
 * absolute, at an avatar's bottom-right corner).
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

export const PresenceDot: FC<{
  /** Diameter in px; defaults to rpx(12). */
  size?: number;
  style?: StyleProp<ViewStyle>;
}> = memo(({ size, style }) => {
  const { rpx } = useResponsiveContext();
  const d = size ?? rpx(12);
  return (
    <View
      style={[
        {
          width: d,
          height: d,
          borderRadius: d / 2,
          backgroundColor: '#22c55e',
          borderWidth: Math.max(1, Math.round(d / 6)),
          borderColor: '#ffffff',
        },
        style,
      ]}
    />
  );
});
